// extracted by mini-css-extract-plugin
export default {"container":"search_container__lz-r7","iconWrapper":"search_iconWrapper__k2Sv6","iconColor":"search_iconColor__0kLTd","input":"search_input__OU007"};